import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import "../common/styles.scss";

Vue.use(VueRouter);

const getPath = p => {
  return `${p}(-de)?`;
};

const routes = [
  {
    path: "/(de)?",
    name: "Home",
    component: Home
  },
  {
    path: getPath("/project"),
    component: () => import("../views/steps/Project.vue")
  },
  {
    path: getPath("/home-type"),
    component: () => import("../views/steps/HomeType.vue")
  },
  {
    path: getPath("/home-size"),
    component: () => import("../views/steps/HomeSize.vue")
  },
  {
    path: getPath("/rooms"),
    component: () => import("../views/steps/Rooms.vue")
  },
  {
    path: getPath("/lighting"),
    component: () => import("../views/steps/Lighting.vue")
  },
  {
    path: getPath("/shading"),
    component: () => import("../views/steps/Shading.vue")
  },
  {
    path: getPath("/Heating"),
    component: () => import("../views/steps/Heating.vue")
  },
  {
    path: getPath("/Cooling"),
    component: () => import("../views/steps/Cooling.vue")
  },
  {
    path: getPath("/Ventilation"),
    component: () => import("../views/steps/Ventilation.vue")
  },
  {
    path: getPath("/sockets"),
    component: () => import("../views/steps/Sockets.vue")
  },
  {
    path: getPath("/alarm-system"),
    component: () => import("../views/steps/Alarm.vue")
  },
  {
    path: getPath("/safety"),
    component: () => import("../views/steps/Safety.vue")
  },
  {
    path: getPath("/access-control"),
    component: () => import("../views/steps/AccessControl.vue")
  },
  {
    path: getPath("/multimedia"),
    component: () => import("../views/steps/Multimedia.vue")
  },
  {
    path: getPath("/other"),
    component: () => import("../views/steps/Other.vue")
  },
  {
    path: getPath("/stage"),
    component: () => import("../views/steps/ProjectStage.vue")
  },
  {
    path: getPath("/wiring"),
    component: () => import("../views/steps/TimeOfWiring.vue")
  },
  {
    path: getPath("/finish"),
    component: () => import("../views/Finish.vue")
  },
  {
    path: getPath("/summary"),
    component: () => import("../views/Summary.vue")
  },
  {
    path: getPath("/thank-you"),
    component: () => import("../views/ThankYou.vue")
  },
  // 404 - must be defined last to catch everything else
  { path: "*", component: () => import("../views/NotFound.vue") }
];

const router = new VueRouter({
  mode: "history",
  // base: "/",
  base: "360/calculator/",
  routes
});

export default router;
